export class AmountUtils {
    static formatAmount(amount?: number, currency?: string): string {
        try {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(amount ?? 0);
        } catch (error) {
            console.error('Error formatting amount:', error);
            return amount?.toString() ?? '0';
        }
    }

    /** Colore dell'importo non pagato rispetto alla soglia di blocco. */
    static usageClass(amount: number | undefined, threshold: number | undefined): string {
        const value = amount ?? 0;
        const limit = threshold && threshold > 0 ? threshold : 100;
        const ratio = value / limit;
        if (ratio >= 1) return 'amount-black';
        if (ratio >= 0.8) return 'amount-red';
        if (ratio >= 0.5) return 'amount-orange';
        return 'amount-green';
    }
}